const modesByDepartment = {
  FTLModes: [
    "FTL - Dry",
    "Expedited",
    "Partial Van (LTL Spot Market)",
    "Car Carrier",
    "Intermodal/Rail",
    "FTL - Dry Team Drivers"
  ],
  TCModes: [
    "Reefer Less than truckload",
    "Reefer Full Truck Load",
    "Reefer Full Truck Load Team Drivers",
    "Reefer Drayage"
  ],
  HHModes: [
    "FTL - F/SD",
    "Partial F/SD",
    "OZ FTL F/SD",
    "FTL - F/SD Team Drivers",
    "Heavy Hauling - Specialized",
    "Power Only - Towing - Driveaway"
  ]
};

module.exports = modesByDepartment;
